export default "__VITE_ASSET__CCluUk5A__"